import cx from 'clsx';
import styles from './styles.module.css';

export const Particles = () => (
  <>
    <img
      src="/images/particle2.webp"
      alt="Particle 2"
      className={cx(styles.particle, styles.particle1)}
      width={68}
      height={67}
      loading="lazy"
      decoding="async"
    />
    <img
      src="/images/particle1.webp"
      alt="Particle 1"
      className={cx(styles.particle, styles.particle2)}
      width={120}
      height={239}
      loading="lazy"
      decoding="async"
    />
  </>
);
